








import { Component, Vue } from "vue-property-decorator";
import { isJpnAprilFool } from "./lambda/submodule/utils";
@Component
export default class App extends Vue {
  myStyle = { width: "100%", height: "100%", background: isJpnAprilFool() ? "#9242a0 url(https://i.imgur.com/MDJ4Zib.png) no-repeat bottom right" : "orange"};
  handleResize(): void {
    // 縦横サイズを調整する
    const w = this.$el.parentElement?.clientWidth as number;
    const h = this.$el.parentElement?.clientHeight as number;
    if (w * 1.5 > h) {
      // 横長
      this.myStyle.height = `${h}px`;
      this.myStyle.width = `${h / 1.5}px`;
    } else {
      // 縦長
      this.myStyle.height = `${w * 1.5}px`;
      this.myStyle.width = `${w}px`;
    }
    this.setFillHeight();
  }
  /** スマホで100vhがうまくないのの対策 */
  setFillHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }
  mounted(): void {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }
  beforeDestroy(): void {
    window.removeEventListener("resize", this.handleResize);
  }
}
